
import { Component, Vue } from 'nuxt-property-decorator'
import { Ivg } from '~/types/models/Ivg'
import meta from '@/helpers/meta'

@Component
export default class IvgAssociatiPage extends Vue {
  public items: Ivg[] = []

  public head() {
    return meta(
      'Ivg Associati',
      'Gli IVG Associati sono specializzati nella custodia e nella vendita di beni immobili, mobili materiali e immateriali provenienti da procedure esecutive ...',
      this.$config.siteUrl + 'img/logo.png',
      this.$config.siteUrl + 'ivg-associati'
    )
  }

  async fetch() {
    const { data } = await this.$axios.get(
      'ivg?limit=100&orderBy[]=denominazione&orderBy[]=asc'
    )
    // rimuovo asta
    data.items.shift()
    this.items = [...data.items]
  }

  fetchOnServer() {
    return true
  }

  getWebsite(item: Ivg) {
    if (item.website === null) {
      return '#'
    }
    return 'http://' + item.website
  }
}
